import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie, X } from "lucide-react";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");

    if (!consent) {
      setTimeout(() => {
        setVisible(true);
      }, 1000);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookieConsent", "accepted");
    setVisible(false);
  };

  const rejectCookies = () => {
    localStorage.setItem("cookieConsent", "rejected");
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 80 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 80 }}
          transition={{ duration: 0.4 }}
          className="fixed bottom-4 left-6 md:left-[25%] z-50 w-[92%] max-w-4xl -translate-x-1/2"
        >
          <div className="relative overflow-hidden rounded-2xl md:rounded-3xl border border-white/10 bg-[#111827] p-4 sm:p-5 md:p-6 shadow-2xl backdrop-blur-xl">
            {/* Glow */}
            <div className="absolute -top-10 -right-10 h-28 w-28 md:h-32 md:w-32 rounded-full bg-orange-500/20 blur-3xl"></div>

            {/* Close Button */}
            <button
              onClick={() => setVisible(false)}
              className="absolute right-3 top-3 md:right-4 md:top-4 text-white/60 transition hover:text-white"
            >
              <X size={18} />
            </button>

            <div className="flex flex-col gap-5 md:flex-row md:items-center md:justify-between">
              {/* Left */}
              <div className="flex items-start gap-3 sm:gap-4">
                <div className="flex h-12 w-12 sm:h-14 sm:w-14 shrink-0 items-center justify-center rounded-2xl bg-orange-500/20 text-orange-400">
                  <Cookie size={24} className="sm:w-7 sm:h-7" />
                </div>

                <div>
                  <h3 className="text-lg sm:text-xl font-semibold text-white">
                    We use cookies
                  </h3>

                  <p className="mt-2 text-xs sm:text-sm leading-5 sm:leading-6 text-gray-300">
                    We use cookies to improve your experience, analyze traffic,
                    and personalize content. By clicking “Accept”, you agree to
                    our cookie policy.
                  </p>
                </div>
              </div>

              {/* Buttons */}
              <div className="flex w-full flex-col sm:flex-row items-stretch sm:items-center gap-3 md:w-auto md:mr-6">
                <button
                  onClick={rejectCookies}
                  className="w-full sm:w-auto rounded-xl border cursor-pointer border-white/10 bg-white/5 px-5 py-3 text-sm font-medium text-white transition hover:bg-white/10"
                >
                  Reject
                </button>

                <button
                  onClick={acceptCookies}
                  className="w-full sm:w-auto rounded-xl bg-orange-500 cursor-pointer px-5 py-3 text-sm font-semibold text-white transition hover:bg-orange-600"
                >
                  Accept
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
